import { render, staticRenderFns } from "./PostCategoryEdit.vue?vue&type=template&id=b93f1a30"
import script from "./PostCategoryEdit.vue?vue&type=script&lang=js"
export * from "./PostCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports